import React, { useMemo, useState, useEffect } from "react";

export default function SSRDemo() {
  const [statusColor, setStatusColor] = useState("purple");

  useEffect(() => {
    setStatusColor("green");
  }, []);

  // This function is meant to slow this component down.
  const heavyComputation = useMemo(() => {
    if (typeof document === "undefined") return null;

    let result = 0;
    for (let i = 0; i < 1e8; i++) {
      result += Math.sqrt(i);
    }
    return result;
  }, []);

  // This renders a fallback UI during server-side rendering (SSR).
  if (typeof document === "undefined") {
    return (
      <div
        className={`tw-bg-${statusColor}-tint-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-shadow-lg`}
        data={heavyComputation}
      >
        <p className="tw-text-lg tw-font-semibold">Server-side rendered!</p>
      </div>
    );
  }

  // This renders the final UI.
  return (
    <div
      className={`tw-bg-${statusColor}-tint-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-shadow-lg`}
      data={heavyComputation}
    >
      <p className="tw-text-lg tw-font-semibold">Everything rendered!</p>
    </div>
  );
}
